import { render } from "./StatsWidgetTabsRender.vue?vue&type=template&id=04b74cc6"
import script from "./StatsWidgetTabsRender.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTabsRender.vue?vue&type=script&lang=ts"
script.render = render

export default script